import { PDivider, PFlex, PButton, PFlexItem } from '@porsche-design-system/components-react'
import React from 'react'

import { TEXTS } from '../../../config/texts'
import { PortalContext } from '../../../utils/PortalContext'

import styles from './contentheader.module.css'

type Props = React.PropsWithChildren<{}>

const ContentHeader = ({ children }: Props) => {
  const { setOpenDrawer, setDrawerContent, setDrawerData } = React.useContext(PortalContext)

  const openMenu = () => {
    setDrawerData({})
    setOpenDrawer(true)
    setDrawerContent('TabletMenu')
  }

  return (
    <React.Fragment>
      <PFlex className={styles.header} alignItems='center'>
        <PFlexItem className={styles.menuTablet}>
          <PButton variant='tertiary' icon='menu-lines' onClick={openMenu} className={styles.menuButton}>
            {TEXTS.CONTENT_HEADER_MENU}
          </PButton>
        </PFlexItem>
        {children}
      </PFlex>
      <PDivider />
    </React.Fragment>
  )
}

export default ContentHeader
